import { render, staticRenderFns } from "./RanksAdmin.vue?vue&type=template&id=0b5c4f4d&scoped=true&"
import script from "./RanksAdmin.vue?vue&type=script&lang=js&"
export * from "./RanksAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5c4f4d",
  null
  
)

export default component.exports